// STE-47: the own side drawer (openSideDrawer/closeSideDrawer, .drawer[data-drawer]) was replaced by the
// theme drawer <x-drawer> – see snippets/info-drawer.liquid and assets/info-drawer.js.

function getCurrentWeglotLanguage(forcedLanguage) {
	const forced = typeof forcedLanguage === "string"
		? forcedLanguage.toLowerCase().split("-")[0]
		: ""
	if (["de", "en", "nl", "fr", "it", "es"].includes(forced)) return forced

	const switcherLanguage = document.querySelector(
		".weglot-container .wgcurrent[data-l]",
	)?.dataset.l
	const pathLanguage = window.location.pathname.split("/")[1]
	const supportedPathLanguage = ["de", "en", "nl", "fr", "it", "es"].includes(
		pathLanguage,
	)
		? pathLanguage
		: ""
	const apiLanguage =
		typeof window.Weglot?.getCurrentLang === "function"
			? window.Weglot.getCurrentLang()
			: ""

	return (switcherLanguage || supportedPathLanguage || apiLanguage || "de")
		.toLowerCase()
		.split("-")[0]
}

function syncWeglotLanguageClasses(forcedLanguage) {
	const languageCode = getCurrentWeglotLanguage(forcedLanguage)

	document.querySelectorAll("[data-weglot-language-class]").forEach((element) => {
		Array.from(element.classList)
			.filter((className) => /^product-tab-[a-z]{2}$/.test(className))
			.forEach((className) => element.classList.remove(className))

		element.classList.add(`product-tab-${languageCode}`)
		element.dataset.languageCode = languageCode
	})

	updateProductReviewTabLabels()
	updateWeglotPriceLabels()
	localizePrices(document, languageCode)
	updateLegalGuaranteeNotices(document, languageCode)
}

const REVIEW_TAB_LABELS = {
	de: { reviews: "Bewertungen", noReviews: "Keine Bewertungen" },
	en: { reviews: "Reviews", noReviews: "No reviews" },
	nl: { reviews: "Recensies", noReviews: "Geen recensies" },
	fr: { reviews: "Avis", noReviews: "Aucun avis" },
	it: { reviews: "Recensioni", noReviews: "Nessuna recensione" },
	es: { reviews: "Reseñas", noReviews: "No hay reseñas" },
}

function getReviewTabLabels() {
	return REVIEW_TAB_LABELS[getCurrentWeglotLanguage()] || REVIEW_TAB_LABELS.de
}

function updateWeglotPriceLabels(root = document) {
	const languageCode = getCurrentWeglotLanguage()
	const labels = root.matches?.("[data-weglot-price-label]")
		? [root]
		: [...root.querySelectorAll("[data-weglot-price-label]")]

	labels.forEach((element) => {
		const label =
			element.getAttribute(`data-label-${languageCode}`) ||
			element.getAttribute("data-label-de")
		if (label && element.textContent !== label) element.textContent = label
	})
}

// Localised price format (STE-21). Liquid always renders German prices ("1.029,00 €"),
// because behind the Weglot proxy it does not know the language. Amounts rendered by
// snippets/localized-money.liquid carry data-money-cents and are reformatted here;
// plain German amounts that theme.js writes into <sale-price>/<compare-at-price> on
// variant change are wrapped and reformatted as well.
const PRICE_NUMBER_LOCALES = {
	de: "de-DE",
	en: "en-GB",
	nl: "nl-NL",
	fr: "fr-FR",
	it: "it-IT",
	es: "es-ES",
}
const PRICE_CURRENCY = "EUR"
const GERMAN_MONEY_PATTERN = /^(€\s*)?(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})\s*(€)?(\s*EUR)?$/
const priceFormatters = {}

function formatLocalizedMoney(cents, languageCode, withCurrency) {
	const locale = PRICE_NUMBER_LOCALES[languageCode] || PRICE_NUMBER_LOCALES.de
	priceFormatters[locale] ||= new Intl.NumberFormat(locale, {
		style: "currency",
		currency: PRICE_CURRENCY,
	})
	const formatted = priceFormatters[locale].format(cents / 100)
	return withCurrency ? `${formatted} ${PRICE_CURRENCY}` : formatted
}

function parseGermanMoney(text) {
	const match = text.trim().match(GERMAN_MONEY_PATTERN)
	if (!match || (!match[1] && !match[4])) return null
	return {
		cents: Number(match[2].replace(/\./g, "")) * 100 + Number(match[3]),
		withCurrency: Boolean(match[5]),
	}
}

function localizeMoneyElement(element, languageCode) {
	if (!element.hasAttribute("data-money-de")) {
		element.setAttribute("data-money-de", element.textContent)
	}
	const cents = Number(element.getAttribute("data-money-cents"))
	const text =
		languageCode === "de" || !Number.isFinite(cents)
			? element.getAttribute("data-money-de")
			: formatLocalizedMoney(
					cents,
					languageCode,
					element.hasAttribute("data-money-with-currency"),
				)
	if (element.textContent !== text) element.textContent = text
}

function localizePrices(root = document, languageCode = getCurrentWeglotLanguage()) {
	if (!root.querySelectorAll) return

	// Wrap plain German amounts written by theme.js (variant change).
	const priceHosts = root.matches?.("sale-price, compare-at-price")
		? [root]
		: [...root.querySelectorAll("sale-price, compare-at-price")]
	priceHosts.forEach((host) => {
		;[...host.childNodes].forEach((node) => {
			if (node.nodeType !== Node.TEXT_NODE) return
			const money = parseGermanMoney(node.textContent)
			if (!money) return
			const span = document.createElement("span")
			span.className = "money"
			span.setAttribute("data-wg-notranslate", "")
			span.setAttribute("data-money-cents", String(money.cents))
			if (money.withCurrency) span.setAttribute("data-money-with-currency", "")
			span.textContent = node.textContent.trim()
			node.replaceWith(span)
		})
	})

	const moneyElements = root.matches?.("[data-money-cents]")
		? [root]
		: [...root.querySelectorAll("[data-money-cents]")]
	moneyElements.forEach((element) => localizeMoneyElement(element, languageCode))
}

function updateLegalGuaranteeNotices(root = document, languageCode = getCurrentWeglotLanguage()) {
	// The notice markup and its language logic live in snippets/legal-guarantee-notice.liquid.
	window.sternzeitLegalNotice?.update(root, languageCode)
}

function updateProductReviewTabLabels(root = document) {
	const labels = getReviewTabLabels()
	const tabs = root.matches?.('product-tab[type="reviews"]')
		? [root]
		: [...root.querySelectorAll('product-tab[type="reviews"]')]

	tabs.forEach((tab) => {
		const jdgmWidget = tab.querySelector(".jdgm-prev-badge")
		const ratingEl = tab.querySelector(".jdgm-prev-badge__rating")
		if (!jdgmWidget || !ratingEl) return

		const count = jdgmWidget.getAttribute("data-number-of-reviews")
		ratingEl.setAttribute("data-wg-notranslate", "")

		if (Number(count) === 0) {
			ratingEl.textContent = labels.noReviews
			return
		}

		ratingEl.textContent = `${labels.reviews}: ${jdgmWidget.getAttribute("data-average-rating")}`
	})
}

syncWeglotLanguageClasses()

const weglotSwitcher = document.querySelector(".weglot-container")
if (weglotSwitcher) {
	new MutationObserver(syncWeglotLanguageClasses).observe(weglotSwitcher, {
		attributes: true,
		childList: true,
		subtree: true,
	})
}

function bindWeglotLanguageChange() {
	if (typeof window.Weglot?.on !== "function") return false
	window.Weglot.on("languageChanged", syncWeglotLanguageClasses)
	return true
}

if (!bindWeglotLanguageChange()) {
	document.addEventListener(
		"weglot.initialized",
		() => {
			bindWeglotLanguageChange()
			syncWeglotLanguageClasses()
		},
		{ once: true },
	)
}

if (document.documentElement) {
	new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (node.nodeType !== 1) continue
				if (
					node.matches?.("[data-legal-notice]") ||
					node.querySelector?.("[data-legal-notice]")
				) {
					updateLegalGuaranteeNotices()
					return
				}
			}
		}
	}).observe(document.documentElement, { childList: true, subtree: true })

	// Re-apply localised prices to re-rendered parts (cart drawer, variant change, quick view).
	new MutationObserver((mutations) => {
		const roots = new Set()
		for (const mutation of mutations) {
			const target =
				mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement
			const host = target?.closest?.("sale-price, compare-at-price")
			if (host) roots.add(host)
			for (const node of mutation.addedNodes) {
				if (node.nodeType !== 1 || host) continue
				if (
					node.matches("[data-money-cents], [data-weglot-price-label], sale-price, compare-at-price") ||
					node.querySelector("[data-money-cents], [data-weglot-price-label], sale-price, compare-at-price")
				) {
					roots.add(node)
				}
			}
		}
		if (!roots.size) return
		const languageCode = getCurrentWeglotLanguage()
		roots.forEach((root) => {
			if (!root.isConnected) return
			updateWeglotPriceLabels(root)
			localizePrices(root, languageCode)
		})
	}).observe(document.documentElement, { childList: true, subtree: true })
}

// STE-28: Neu geladenes Warenkorb-HTML (Abschnitte aus cart/add.js, cart/change.js oder
// ?section_id=) kann über den Sprachpfad schon von Weglot übersetzt sein. Weglot würde es nach
// dem Einsetzen ein zweites Mal übersetzen und den fremden Text als Deutsch lesen (NL „Leer“ →
// „Leeg“). Die Probe in sections/cart-drawer.liquid trägt den deutschen Text im Attribut;
// weicht der Elementtext davon ab, ist das HTML bereits übersetzt und wird mit
// data-wg-notranslate vor einer zweiten Übersetzung geschützt. Deutsches HTML bleibt
// unverändert und wird wie bisher von Weglot übersetzt.
function sdMarkPreTranslatedHtml(root, selector) {
	const probe = root?.querySelector?.("[data-translation-probe]")
	if (!probe) return false
	const german = (probe.getAttribute("data-translation-probe") || "").trim()
	const text = (probe.textContent || "").trim()
	if (!german || !text || german === text) return false
	root.querySelectorAll(selector).forEach((element) => {
		element.setAttribute("data-wg-notranslate", "")
	})
	return true
}

if (typeof window !== "undefined") {
	window.sdMarkPreTranslatedHtml = sdMarkPreTranslatedHtml
}

const TYPE_PICKER_PAGE_LOADING_ID = "type-picker-page-loading-overlay"

function setTypePickerPageLoading(active) {
	const body = document.body
	if (!active) {
		body.classList.remove("type-picker-page-loading")
		const el = document.getElementById(TYPE_PICKER_PAGE_LOADING_ID)
		if (el) el.hidden = true
		return
	}
	let el = document.getElementById(TYPE_PICKER_PAGE_LOADING_ID)
	if (!el) {
		el = document.createElement("div")
		el.id = TYPE_PICKER_PAGE_LOADING_ID
		el.className = "type-picker-page-loading-overlay"
		el.setAttribute("role", "status")
		el.setAttribute("aria-live", "polite")
		el.innerHTML =
			'<span class="sr-only">Loading product</span><div class="type-picker-page-loading-overlay__spinner" aria-hidden="true"></div>'
		document.body.appendChild(el)
	}
	el.hidden = false
	body.classList.add("type-picker-page-loading")
	document.querySelectorAll(".info-drawer[open]").forEach((drawer) => drawer.hide?.())
}

class TypePicker extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.addEventListener("click", async (e) => {
			const sectionUrl = this.getAttribute("data-section-url")
			let sectionId = this.getAttribute("data-section-id")
			if (!sectionId) {
				const sec = this.closest(".shopify-section")
				if (sec?.id) sectionId = sec.id.replace("shopify-section-", "")
			}

			// Fabric / product-sibling picker: replace the whole main product section (Section Rendering API)
			if (sectionUrl && sectionId) {
				e.preventDefault()
				const targetUrl = new URL(sectionUrl, window.location.origin)
				if (targetUrl.pathname === window.location.pathname) return

				const shopifySection = document.getElementById(`shopify-section-${sectionId}`)
				if (!shopifySection) return

				setTypePickerPageLoading(true)
				shopifySection.classList.add("is-loading")
				const fetchUrl = new URL(sectionUrl, window.location.origin)
				fetchUrl.searchParams.set("section_id", sectionId)

				try {
					const res = await fetch(fetchUrl.toString())
					if (!res.ok) return
					const html = await res.text()
					const doc = new DOMParser().parseFromString(html, "text/html")
					const incoming =
						doc.getElementById(`shopify-section-${sectionId}`) ||
						doc.querySelector(".shopify-section")
					if (!incoming) return

					shopifySection.replaceChildren(...document.importNode(incoming, true).childNodes)
					syncWeglotLanguageClasses()
					targetUrl.searchParams.delete("section_id")
					history.pushState({}, "", targetUrl.toString())
					const h1 = shopifySection.querySelector("h1")
					if (h1?.textContent) document.title = h1.textContent.trim()
				} catch (err) {
					console.error("Failed to fetch product section:", err)
				} finally {
					shopifySection.classList.remove("is-loading")
					setTypePickerPageLoading(false)
				}
				return
			}
		})
	}
}

window.customElements.define("type-picker", TypePicker)

class ProductTab extends HTMLElement {
	constructor() {
		super()
	}
	connectedCallback() {
		if (this.getAttribute("type") === "reviews") {
			const jdgmWidget = this.querySelector(".jdgm-prev-badge")
			if (jdgmWidget) {
				const count = jdgmWidget.getAttribute("data-number-of-reviews")
				if (Number(count) === 0) {
					this.classList.add("no-reviews")
					document.querySelectorAll("#judgeme_product_reviews").forEach((r) => {
						if (r.closest(".shopify-section--apps"))
							r.closest(".shopify-section--apps").classList.add("hidden")
					})
				}
				document.querySelectorAll(".jdgm-prev-badge__count").forEach((r) => {
					if (Number(count) !== 0) r.textContent = `(${count})`
				})
				updateProductReviewTabLabels(this)
			}
		}
	}
}
window.customElements.define("product-tab", ProductTab)

class MoreToggle extends HTMLElement {
	constructor() {
		super()
		this.open = false
	}
	connectedCallback() {
		this.addEventListener("click", () => {
			this.previousElementSibling.classList.toggle("truncate")
			this.open = !this.open
			this.textContent = this.open
				? `... ${this.getAttribute("data-less-text")}`
				: `... ${this.getAttribute("data-more-text")}`
		})
	}
}
window.customElements.define("more-toggle", MoreToggle)

class FabricTypeToggle extends HTMLElement {
	constructor() {
		super()
		this.expanded = false
	}

	connectedCallback() {
		if (this.dataset.initialized === "true") return
		this.dataset.initialized = "true"

		this.list = this.previousElementSibling
		if (!this.list) return

		this.moreText = this.getAttribute("data-more-text") || "Show more"
		this.lessText = this.getAttribute("data-less-text") || "Show less"

		this.setAttribute("role", "button")
		this.setAttribute("tabindex", "0")
		this.textContent = this.moreText

		this.addEventListener("click", this.toggle.bind(this))
		this.addEventListener("keydown", (e) => {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault()
				this.toggle()
			}
		})
	}

	toggle() {
		this.expanded = !this.expanded
		this.list.classList.toggle("is-collapsed", !this.expanded)
		this.textContent = this.expanded ? this.lessText : this.moreText
	}
}
window.customElements.define("fabric-type-toggle", FabricTypeToggle)

const headerGrp = document.querySelector(".header-grp-sticky")
let lastScrollY = window.scrollY
window.addEventListener("scroll", (e) => {
	const currentScrollY = window.scrollY
	if (currentScrollY > headerGrp.clientHeight) {
		if (currentScrollY > lastScrollY) {
			headerGrp.classList.add("hide-header")
		} else if (currentScrollY < lastScrollY) {
			headerGrp.classList.remove("hide-header")
		}
	} else {
		headerGrp.classList.remove("hide-header")
	}

	lastScrollY = currentScrollY
})
const injectStyles = () => {
	const el = document.querySelector("inbox-online-store-chat")

	// 1. Check if the element exists and HAS a shadowRoot
	if (el && el.shadowRoot) {
		// 2. Check if the internal content (.chat-title) actually exists yet
		const target = el.shadowRoot.querySelector(".chat-app")
		console.log("injject", target)

		if (target) {
			console.log("target")

			const style = document.createElement("style")
			style.textContent = `
		
        .chat-title { display: none !important; }
				button.chat-toggle.chat-toggle--text-button,
				button.chat-toggle.chat-toggle--icon-button {
				    width: 44px!important;
    height: 44px!important;
    padding: 0!important;
    margin: 0!important;
    max-width: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
		background: #F1B00B!important;
		  
				}
.chat-app.chat-app-- {
    display: flex;
		flex-direction: column;
    justify-content: end;
    align-items: end;
		max-width: 376px;
    margin-left: auto;
		pointer-events: all;
		width: fit-content;
		&.chat-app--is-mobile {
    margin-left: auto;
    margin-right: 12px;
	}
}
	.chat-app--is-open:not(.chat-app--is-mobile) {
	margin-right: 0px;}
	.chat-toggle:after {
	    translate: 0 2px;}
			.chat-app.chat-app--is-open {
		pointer-events: all;
		}
		.chat-app .chat-app--close-button-bottom-right {
    margin-left: auto;
		width: 44px;
    height: 44px;
    margin: 10px 0;
}
				button.chat-toggle {
					background: #F1B00B!important;
					} 
				

        .chat-toggle svg { display: none !important; }
				.chat-toggle:after {
				content: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.45455 16L0 19.5V1C0 0.44772 0.44772 0 1 0H19C19.5523 0 20 0.44772 20 1V15C20 15.5523 19.5523 16 19 16H4.45455ZM3.76282 14H18V2H2V15.3851L3.76282 14ZM9 7H11V9H9V7ZM5 7H7V9H5V7ZM13 7H15V9H13V7Z" fill="%23141311"/></svg>');
				}
      `
			el.shadowRoot.appendChild(style)
			const idChatApp = document.getElementById("shopify-chat")
			if (idChatApp) idChatApp.classList.add("loaded")
			console.log("Styles successfully injected!")
			return true // Success!
		}
	}
	return false // Not ready yet
}

// Use an interval to "poll" until the widget is fully rendered
const poll = setInterval(() => {
	if (injectStyles()) {
		clearInterval(poll) // Stop once successful
	}
}, 500) // Check every 0.5 seconds

// Safety: Stop trying after 10 seconds so it doesn't run forever
setTimeout(() => clearInterval(poll), 10000)

const jdgmReviews = document.querySelectorAll(".jdgm-review-widget")

setTimeout(() => {
	jdgmReviews.forEach((el) => {
		const wrapper = el.querySelector(".jdgm-rev-widg")
		if (!wrapper) return
		const avarage = el.querySelector(".jdgm-rev-widg__summary-average")
		const data_avarage = wrapper.getAttribute("data-average-rating")
		if (avarage && data_avarage) {
			avarage.textContent = data_avarage
			const clone = avarage.cloneNode(true)
			const inner = el.querySelector(".jdgm-rev-widg__summary-inner")
			if (inner) inner.appendChild(clone)
		}
	})
}, 500)

document.addEventListener("click", (e) => {
	if (e.target.closest(".needsclick") || e.target.classList.contains("needsclick")) {
		let topMostNeedsclick = e.target.closest(".needsclick")
		let current = topMostNeedsclick
		while (current && current.parentElement) {
			if (
				current.parentElement.classList &&
				current.parentElement.classList.contains("needsclick")
			) {
				topMostNeedsclick = current.parentElement
				current = current.parentElement
			} else {
				break
			}
		}

		const form = topMostNeedsclick.querySelector('.needsclick[data-testid="POPUP"')
		if (form) {
			setTimeout(() => {
				const computedOpacity = window.getComputedStyle(form).opacity
				console.log(computedOpacity.toString())
				if (computedOpacity.toString() !== "1") {
					topMostNeedsclick.remove()
					document.body.classList.remove("klaviyo-prevent-body-scrolling")
				}
			}, 300)
		}
	}
})

// ---------------------------------------------------------------------------
// STE-12: Suche in Fremdsprachen
// Shopify sucht nur in den deutschen Produktdaten, Weglot übersetzt den
// Suchbegriff nicht (Suchübersetzung in Weglot ist aus). Hier fragen wir
// Weglot selbst nach der deutschen Übersetzung und suchen mit dem
// Originalwort UND der Übersetzung:
// - Header-Suche: beide Ergebnislisten zusammenführen.
// - Ergebnisseite: mit dem Wort suchen, das die passenderen Produkte liefert.
//   (Kein „x OR y“: damit schaltet Shopify die unscharfe Suche ab, z. B.
//   findet „schaukelstuhl“ allein die Schaukelsessel, mit OR nicht mehr.)
// So bleibt auffindbar, was heute mit dem Originalwort klappt (Beam, Cube,
// Velvet …), und es kommt hinzu, was nur deutsch gefunden wird (panca → Bank).
// Nur in Fremdsprachen; Deutsch bleibt unverändert. Antwortet Weglot nicht
// rechtzeitig, wird wie bisher nur mit dem Originalwort gesucht.
// ---------------------------------------------------------------------------

const SEARCH_TRANSLATION_TIMEOUT_MS = 800
const SEARCH_SUBMIT_TIMEOUT_MS = 2000
const searchTranslationCache = new Map()

function isForeignSearchLanguage() {
	return (
		getCurrentWeglotLanguage() !== "de" &&
		typeof window.Weglot?.search === "function"
	)
}

function translateSearchTerm(term) {
	const original = (term || "").trim()
	if (original.length < 3) return Promise.resolve(null)

	const cacheKey = `${getCurrentWeglotLanguage()}|${original.toLowerCase()}`
	if (searchTranslationCache.has(cacheKey)) {
		return Promise.resolve(searchTranslationCache.get(cacheKey))
	}

	return new Promise((resolve) => {
		let settled = false
		const finish = (value) => {
			if (settled) return
			settled = true
			clearTimeout(timer)
			resolve(value)
		}
		const timer = setTimeout(() => finish(null), SEARCH_TRANSLATION_TIMEOUT_MS)

		try {
			window.Weglot.search(original, (translated) => {
				const value =
					typeof translated === "string" &&
					translated.trim() !== "" &&
					translated.trim().toLowerCase() !== original.toLowerCase()
						? translated.trim()
						: null
				searchTranslationCache.set(cacheKey, value)
				finish(value)
			})
		} catch (error) {
			finish(null)
		}
	})
}

function predictiveSearchSectionId() {
	return document.querySelector("predictive-search")?.getAttribute("section-id") || ""
}

// Vorschlagsliste der Header-Suche für einen Begriff laden (HTML, von Weglot übersetzt).
async function loadPredictiveSection(term, sectionId, signal) {
	const params = new URLSearchParams({
		q: term,
		section_id: sectionId,
		"resources[limit]": "10",
		"resources[limit_scope]": "each",
	})
	const response = await fetch(`${window.Shopify.routes.root}search/suggest?${params}`, { signal })
	return new DOMParser().parseFromString(await response.text(), "text/html")
}

function productLinksOf(doc) {
	// Produkt-Treffer erkennt man am Preis (Beiträge/Seiten haben keinen).
	// Nicht an der URL: Weglot übersetzt /products/ (z. B. /it/prodotti/).
	return [...doc.querySelectorAll('[slot="results"] a.predictive-search-result')].filter(
		(link) => link.querySelector("price-list, .price-list"),
	)
}

// Wie viele Produktnamen passen zu einem der beiden Wörter? Titel können deutsch
// oder schon von Weglot übersetzt sein, deshalb beide Wörter prüfen.
function countMatchingProductTitles(doc, terms) {
	const tokens = terms
		.join(" ")
		.toLowerCase()
		.split(/[\s-]+/)
		.filter((token) => token.length >= 3)
		.map((token) => token.slice(0, 6))
	if (!tokens.length) return 0
	return productLinksOf(doc).filter((link) => {
		const title = link.textContent.toLowerCase()
		return tokens.some((token) => title.includes(token))
	}).length
}

// Original und Übersetzung abfragen; Übersetzung gewinnt nur, wenn ihre
// Treffer besser passen (bei Gleichstand bleibt es beim Original wie heute).
async function compareSearchTerms(original, translated, signal) {
	const sectionId = predictiveSearchSectionId()
	const [originalDoc, translatedDoc] = await Promise.all([
		loadPredictiveSection(original, sectionId, signal),
		loadPredictiveSection(translated, sectionId, signal),
	])
	const terms = [original, translated]
	const translatedFirst =
		countMatchingProductTitles(translatedDoc, terms) >
		countMatchingProductTitles(originalDoc, terms)
	return { originalDoc, translatedDoc, translatedFirst }
}

function mergePredictiveResults(primaryDoc, secondaryDoc, limit) {
	const primaryLinks = productLinksOf(primaryDoc)
	const secondaryLinks = productLinksOf(secondaryDoc)
	if (!primaryLinks.length) return secondaryDoc
	if (!secondaryLinks.length) return primaryDoc

	const container = primaryLinks[0].parentElement
	const seen = new Set()
	const merged = []
	for (const link of [...primaryLinks, ...secondaryLinks]) {
		const key = new URL(link.getAttribute("href"), window.location.origin).pathname
		if (seen.has(key)) continue
		seen.add(key)
		merged.push(link)
		if (merged.length >= limit) break
	}

	primaryLinks.forEach((link) => link.remove())
	merged.forEach((link) => container.appendChild(primaryDoc.importNode(link, true)))
	return primaryDoc
}

// Ergebnisseite und „Alle anzeigen“: vor dem Absenden das passendere Wort
// wählen und in der Sprachversion bleiben.
async function chooseSubmitTerm(original) {
	const translated = await translateSearchTerm(original)
	if (!translated) return original
	const { translatedFirst } = await compareSearchTerms(original, translated)
	return translatedFirst ? translated : original
}

document.addEventListener(
	"submit",
	async (event) => {
		const form = event.target
		if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"]')) return
		if (form.dataset.searchTranslated === "1" || !isForeignSearchLanguage()) return

		const input = form.querySelector('input[name="q"]')
		const original = input?.value.trim()
		if (!original) return

		// Erst das Wort wählen, dann neu absenden. Andere Listener sollen erst
		// beim zweiten Absenden laufen.
		event.preventDefault()
		event.stopImmediatePropagation()

		let term = original
		try {
			term = await Promise.race([
				chooseSubmitTerm(original),
				new Promise((resolve) => setTimeout(() => resolve(original), SEARCH_SUBMIT_TIMEOUT_MS)),
			])
		} catch (error) {
			term = original
		}

		if (term !== original) {
			const addHidden = (name, value) => {
				const hidden = document.createElement("input")
				hidden.type = "hidden"
				hidden.name = name
				hidden.value = value
				hidden.dataset.searchTranslation = ""
				form.appendChild(hidden)
			}
			addHidden("q", term)
			// Eingegebenes Wort mitgeben, damit die Ergebnisseite es anzeigt.
			addHidden("oq", original)
			input.removeAttribute("name")
		}

		// Das Formular zeigt auf „/search“ (deutsche Seite). In Fremdsprachen auf
		// die Sprachversion umleiten (/it/search → Weglot macht /it/cerca daraus),
		// sonst landet die Suche auf der deutschen Ergebnisseite.
		const root = window.Shopify?.routes?.root || "/"
		if (form.getAttribute("action") === "/search" && root !== "/") {
			form.dataset.searchOriginalAction = "/search"
			form.setAttribute("action", `${root}search`)
		}

		form.dataset.searchTranslated = "1"
		// requestSubmit löst das submit-Ereignis erneut aus; unser Listener lässt
		// es dank data-search-translated durch.
		if (typeof form.requestSubmit === "function") form.requestSubmit()
		else HTMLFormElement.prototype.submit.call(form)
	},
	true,
)

// Zurück-Taste (Seite aus dem Browser-Cache): Formulare wieder herstellen.
window.addEventListener("pageshow", () => {
	document.querySelectorAll('form[data-search-translated="1"]').forEach((form) => {
		form.querySelectorAll("input[data-search-translation]").forEach((el) => el.remove())
		const input = form.querySelector('input[type="search"]:not([name])')
		if (input) input.setAttribute("name", "q")
		if (form.dataset.searchOriginalAction) {
			form.setAttribute("action", form.dataset.searchOriginalAction)
			delete form.dataset.searchOriginalAction
		}
		delete form.dataset.searchTranslated
	})
})

// Ergebnisseite: überall das eingegebene Wort anzeigen, nicht das deutsche.
function restoreSearchTermDisplay() {
	if (getCurrentWeglotLanguage() === "de") return
	const params = new URLSearchParams(window.location.search)
	const original = (params.get("oq") || "").trim()
	const query = (params.get("q") || "").trim()
	if (!original || !query || original === query) return

	document.querySelectorAll('.main-search-form input[name="q"]').forEach((input) => {
		if (input.value === query) input.value = original
	})

	// Der Begriff steht in Anführungszeichen; Weglot kann das deutsche Wort darin
	// übersetzt haben, deshalb den ganzen Inhalt der Anführungszeichen ersetzen.
	const quoted = /(["«“„])([^"«»“”„]+)(["»”“])/
	const replaceQuoted = (text) => text.replace(quoted, (match, open, inner, close) => `${open}${original}${close}`)

	const replaceIn = (root) => {
		const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
		let node
		while ((node = walker.nextNode())) {
			if (!quoted.test(node.nodeValue)) continue
			const next = replaceQuoted(node.nodeValue)
			if (next !== node.nodeValue) node.nodeValue = next
		}
	}

	if (quoted.test(document.title)) document.title = replaceQuoted(document.title)

	document.querySelectorAll("main h1, main [role='status']").forEach((element) => {
		replaceIn(element)
		// Weglot kann die Überschrift nachträglich neu schreiben.
		new MutationObserver(() => replaceIn(element)).observe(element, {
			childList: true,
			subtree: true,
			characterData: true,
		})
	})
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", restoreSearchTermDisplay)
} else {
	restoreSearchTermDisplay()
}

// Header-Suche (Vorschläge beim Tippen): Originalwort und Übersetzung getrennt
// abfragen und die Produkte zusammenführen, die passendere Liste zuerst.
window.customElements.whenDefined("predictive-search").then(() => {
	const PredictiveSearch = window.customElements.get("predictive-search")
	const originalSearch = PredictiveSearch?.prototype?._doPredictiveSearch
	if (typeof originalSearch !== "function") return

	PredictiveSearch.prototype._doPredictiveSearch = async function () {
		if (!isForeignSearchLanguage()) return originalSearch.call(this)

		const original = this._queryInput.value.trim(), signal = this._abortController?.signal
		await this._transitionToSlot("loading")

		const translated = await translateSearchTerm(original)
		if (signal?.aborted) return
		if (!translated) return originalSearch.call(this)

		let comparison
		try {
			comparison = await compareSearchTerms(original, translated, signal)
		} catch (error) {
			if (error.name === "AbortError") return
			return originalSearch.call(this)
		}

		const { originalDoc, translatedDoc, translatedFirst } = comparison
		const resultDoc = translatedFirst
			? mergePredictiveResults(translatedDoc, originalDoc, 10)
			: mergePredictiveResults(originalDoc, translatedDoc, 10)

		const results = resultDoc.querySelector('[slot="results"]')
		if (!results || signal?.aborted) return
		window.sdProtectTranslatedHtml?.([results], window.Shopify.routes.root) // STE-50: schon übersetzt, nicht erneut übersetzen
		this.querySelector('[slot="results"]').replaceWith(document.importNode(results, true))
		return this._transitionToSlot("results")
	}
})

// STE-16: Sets und "Vervollständige dein Set".
// Zuordnung im Metaobjekt "Set-Zuordnung" (snippets/set-matches.liquid). Texte rendert Liquid auf
// Deutsch (Weglot übersetzt); hier werden nur Varianten-IDs, Bilder und Preise getauscht.
// Den Rabatt rechnet der automatische Shopify-Rabatt im Warenkorb, nicht dieser Code.

// Line item properties that apps normally put into the product form (the set buttons add via
// cart/add.js and bypass the form): HeartCoding "Original price" (only when the variant is on sale,
// German format like the app) and the tracking reference _wgsRefIDV2 (wtag-shpfy.js).
function sdSetAppProperties(item) {
	const properties = {}
	let hcLabel = null
	const hcInput = document.querySelector(".hc_original_price_prop")
	try {
		if (hcInput) {
			hcLabel = hcInput.name.replace(/^properties\[/, "").replace(/\]$/, "")
			localStorage.setItem("sdHcOriginalPriceLabel", hcLabel)
		} else {
			hcLabel = localStorage.getItem("sdHcOriginalPriceLabel")
		}
	} catch (error) {}
	if (hcLabel && item.compare > item.price) {
		properties[hcLabel] = formatLocalizedMoney(item.compare, "de").replace(/\u00a0/g, " ")
	}
	const reference = document.querySelector('[name="properties[_wgsRefIDV2]"]')?.value
	if (reference) properties._wgsRefIDV2 = reference
	return properties
}

// _set_quelle: hidden line item property (underscore = not shown in cart/checkout) that marks
// items added through the STE-16 buttons, so orders can be evaluated per source.
function sdSetCartItems(items, quelle) {
	return items.map((item) => {
		const properties = sdSetAppProperties(item)
		if (item.quelle || quelle) properties._set_quelle = item.quelle || quelle
		const cartItem = { id: item.id, quantity: item.quantity || 1 }
		if (Object.keys(properties).length) cartItem.properties = properties
		return cartItem
	})
}

async function sdSetAddItems(items, source, quelle) {
	items = sdSetCartItems(items, quelle)
	const sections = []
	document.documentElement.dispatchEvent(
		new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }),
	)
	const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
		method: "POST",
		headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
		body: JSON.stringify({ items, sections: sections.join(","), sections_url: "/" }),
	})
	const json = await response.json()
	if (!response.ok) {
		source.dispatchEvent(
			new CustomEvent("cart:error", { bubbles: true, detail: { error: json.description } }),
		)
		return false
	}
	if (window.themeVariables?.settings?.pageType === "cart") {
		window.location.reload()
		return true
	}
	const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json()
	cart.sections = json.sections
	source.dispatchEvent(
		new CustomEvent("variant:add", {
			bubbles: true,
			detail: { items: json.items || [json], cart },
		}),
	)
	document.documentElement.dispatchEvent(
		new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart } }),
	)
	return true
}

function sdSetMoney(element, cents) {
	if (!element) return
	const money = element.matches("[data-money-cents]")
		? element
		: element.querySelector("[data-money-cents]")
	if (!money) return
	money.setAttribute("data-money-cents", String(cents))
	money.setAttribute("data-money-de", formatLocalizedMoney(cents, "de"))
	localizeMoneyElement(money, getCurrentWeglotLanguage())
}

function sdSetBestVariant(variants, options) {
	let best = null
	let bestScore = -1
	for (const variant of variants) {
		if (!variant.available) continue
		let score = 0
		for (const [name, value] of Object.entries(variant.options)) {
			if (options && options[name] === value) score++
		}
		if (score > bestScore) {
			best = variant
			bestScore = score
		}
	}
	return best
}

async function sdSetRunButton(button, items, source, quelle) {
	if (button.getAttribute("aria-busy") === "true") return
	button.setAttribute("aria-busy", "true")
	button.disabled = true
	try {
		await sdSetAddItems(items, source, quelle)
	} finally {
		button.removeAttribute("aria-busy")
		button.disabled = false
	}
}

class SetOffer extends HTMLElement {
	// Compact variant (20.10.2026): checkbox rows above the add-to-cart button, never preselected.
	// The normal button adds the main product (theme ProductForm); afterwards the checked rows
	// are added here (variant:add on the main form).
	connectedCallback() {
		this.form = document.getElementById(this.dataset.formId)
		this.percent = Number(this.dataset.percent) || 0
		this.mode = this.dataset.mode
		try {
			this.mainVariants = JSON.parse(this.querySelector("[data-set-main]").textContent)
		} catch (error) {
			this.mainVariants = {}
		}
		this.candidates = [...this.querySelectorAll("script[data-set-candidate]")].map((script) => {
			const data = JSON.parse(script.textContent)
			return { variants: data.variants, image: data.image, url: data.url, variant: null }
		})
		this.row = this.querySelector("[data-set-row]")
		this.partnerCheckbox = this.querySelector("[data-set-partner]")

		this._onVariantChange = (event) => {
			if (event.target === this.form) this.update(event.detail?.variant?.id)
		}
		this._onVariantAdd = (event) => {
			if (event.target === this.form) this.addChecked()
		}
		document.addEventListener("variant:change", this._onVariantChange)
		document.addEventListener("variant:add", this._onVariantAdd)
		this.row?.addEventListener("click", (event) => {
			if (event.target.closest("input, label, a")) return
			this.partnerCheckbox.click()
		})
		this.update()
	}

	disconnectedCallback() {
		document.removeEventListener("variant:change", this._onVariantChange)
		document.removeEventListener("variant:add", this._onVariantAdd)
	}

	get mainVariantId() {
		return this.form?.querySelector('[name="id"]')?.value
	}

	get quantity() {
		const input = document.querySelector(".product-info .quantity-selector__input")
		return Math.max(1, parseInt(input?.value, 10) || 1)
	}

	get selectedCandidate() {
		return this.candidates[0]
	}

	discounted(cents) {
		return Math.round((cents * (100 - this.percent)) / 100)
	}

	update(variantId = this.mainVariantId) {
		const main = this.mainVariants[String(variantId)]
		this.candidates.forEach((candidate) => {
			candidate.variant = sdSetBestVariant(candidate.variants, main?.options)
		})
		const candidate = this.selectedCandidate
		const variant = candidate?.variant
		if (this.row) {
			this.row.hidden = !variant
			if (!variant && this.partnerCheckbox) this.partnerCheckbox.checked = false
		}
		if (!variant) return

		const image = this.row?.querySelector(".set-offer__image")
		if (image) {
			// Variants without an own image (e.g. with piping): image of the most similar variant.
			const withImage = variant.image
				? variant
				: sdSetBestVariant(
						candidate.variants.filter((other) => other.image).map((other) => ({ ...other, available: true })),
						variant.options,
					)
			image.src = withImage?.image || candidate.image || image.src
			image.removeAttribute("srcset")
		}
		if (this.percent > 0) {
			sdSetMoney(this.querySelector("[data-set-price-new]"), this.discounted(variant.price))
			sdSetMoney(this.querySelector("[data-set-price-old]"), variant.price)
		} else {
			sdSetMoney(this.querySelector("[data-set-price]"), variant.price)
		}
	}

	addChecked() {
		const items = []
		const variant = this.selectedCandidate?.variant
		if (this.partnerCheckbox?.checked && variant && this.row && !this.row.hidden) {
			items.push({
				id: variant.id,
				quantity: this.quantity,
				price: variant.price,
				compare: variant.compare,
				quelle: "Produktseite Set",
			})
		}
		this.querySelectorAll("[data-set-accessory]:checked").forEach((input) => {
			items.push({
				id: Number(input.value),
				quantity: 1,
				price: Number(input.dataset.price) || 0,
				compare: Number(input.dataset.compare) || 0,
				quelle: "Produktseite Häkchen",
			})
		})
		if (items.length) sdSetAddItems(items, this)
	}
}

if (!window.customElements.get("set-offer")) {
	window.customElements.define("set-offer", SetOffer)
}

document.addEventListener("click", (event) => {
	const button = event.target.closest?.("[data-set-add-items]")
	if (!button) return
	event.preventDefault()
	let items = []
	try {
		items = JSON.parse(button.getAttribute("data-set-add-items"))
	} catch (error) {
		return
	}
	const quelle = button.closest(".set-suggestions--page") ? "Warenkorbseite" : "Seitenwarenkorb"
	sdSetRunButton(button, items, button, quelle)
})

// STE-19: Sprachauswahl (Popup nach Figma „Popup Language“).
// Die Sprachen kommen aus Weglot (Weglot.options bzw. hreflang-Links), nicht aus dem Code;
// neue Weglot-Sprachen erscheinen automatisch. Gewechselt wird immer über die Weglot-URL der
// Sprache (übersetzte Pfade aus den hreflang-Links), nie über Shopify-Sprachen. Sprachnamen
// erzeugt der Browser (Intl.DisplayNames) in der jeweiligen Sprache; sie sind deshalb von
// Weglot ausgenommen (sonst würde z. B. „Deutsch“ als deutscher Text neu übersetzt, vgl. STE-28).
const SD_LANGUAGE_FLAG_ALIASES = { en: "en", "en-gb": "en", "en-us": "en" }

function sdPrimaryLanguage(code) {
	return String(code || "").toLowerCase().split(/[-_]/)[0]
}

// Kürzel für Button und Flaggen-Ersatz. Grundsätzlich der Sprachcode in Großbuchstaben (EN, NL …);
// Ausnahmen nach Vorgabe von Machiel (21.10.2026): Schwedisch zeigt „SE“ statt „SV“.
// Nur die Anzeige – Weglot-URLs und Sprachcodes (/sv/) bleiben unverändert.
const SD_LANGUAGE_LABELS = { sv: "SE" }

function sdLanguageLabel(code) {
	const primary = sdPrimaryLanguage(code)
	return SD_LANGUAGE_LABELS[primary] || primary.toUpperCase()
}

function sdLanguageName(code, displayLanguage) {
	try {
		const name = new Intl.DisplayNames([displayLanguage || code], { type: "language" }).of(code)
		if (name && name.toLowerCase() !== String(code).toLowerCase()) {
			return name.charAt(0).toLocaleUpperCase(displayLanguage || code) + name.slice(1)
		}
	} catch (error) {
		// Intl.DisplayNames fehlt oder kennt den Code nicht
	}
	return String(code).toUpperCase()
}

function sdAlternateLinks() {
	return [...document.querySelectorAll('link[rel="alternate"][hreflang]')]
		.map((link) => ({ code: link.getAttribute("hreflang"), href: link.href }))
		.filter((entry) => entry.code && entry.code.toLowerCase() !== "x-default" && entry.href)
}

function sdOriginalLanguage() {
	return sdPrimaryLanguage(window.Weglot?.options?.language_from) || "de"
}

function sdCurrentLanguage(languages) {
	const codes = languages.map((language) => language.code)
	const candidates = [
		typeof window.Weglot?.getCurrentLang === "function" ? window.Weglot.getCurrentLang() : "",
		document.querySelector(".weglot-container .wgcurrent[data-l]")?.dataset.l,
		window.location.pathname.split("/")[1],
		document.documentElement.lang,
	]
	for (const candidate of candidates) {
		if (!candidate) continue
		const exact = codes.find((code) => code.toLowerCase() === String(candidate).toLowerCase())
		if (exact) return exact
		const primary = codes.find((code) => sdPrimaryLanguage(code) === sdPrimaryLanguage(candidate))
		if (primary) return primary
	}
	return sdOriginalLanguage()
}

function sdAvailableLanguages() {
	const original = sdOriginalLanguage()
	const alternates = sdAlternateLinks()
	const codes = []
	const add = (code) => {
		if (!code) return
		const normalised = String(code).toLowerCase()
		if (!codes.some((existing) => existing.toLowerCase() === normalised)) codes.push(String(code))
	}
	add(original)
	const weglotLanguages = window.Weglot?.options?.languages
	if (Array.isArray(weglotLanguages) && weglotLanguages.length) {
		weglotLanguages
			.filter((language) => language && language.enabled !== false && !language.private)
			.forEach((language) => add(language.custom_code || language.language_to))
	} else {
		alternates.forEach((entry) => add(entry.code))
	}
	return codes.map((code) => {
		const alternate =
			alternates.find((entry) => entry.code.toLowerCase() === code.toLowerCase()) ||
			alternates.find((entry) => sdPrimaryLanguage(entry.code) === sdPrimaryLanguage(code))
		return { code, href: alternate?.href || "" }
	})
}

// Ziel-URL in der gewählten Sprache: hreflang-Link (übersetzter Pfad), sonst Sprachpräfix tauschen.
function sdLanguageTargetUrl(language, languages, location = window.location) {
	let url
	if (language.href) {
		url = new URL(language.href, location.origin)
	} else {
		url = new URL(location.href)
		const prefixes = languages.map((entry) => entry.code.toLowerCase())
		const parts = url.pathname.split("/")
		if (prefixes.includes((parts[1] || "").toLowerCase())) parts.splice(1, 1)
		let path = parts.join("/") || "/"
		if (sdPrimaryLanguage(language.code) !== sdOriginalLanguage()) {
			path = `/${language.code}${path === "/" ? "" : path}`
		}
		url.pathname = path || "/"
	}
	new URLSearchParams(location.search).forEach((value, key) => {
		if (!url.searchParams.has(key)) url.searchParams.set(key, value)
	})
	if (!url.hash && location.hash) url.hash = location.hash
	return url
}

class LanguageSwitcher extends HTMLElement {
	connectedCallback() {
		this.trigger = this.querySelector(".language-switcher__trigger")
		this.dialog = this.querySelector("dialog")
		this.form = this.querySelector("[data-language-form]")
		this.optionsRoot = this.querySelector("[data-language-options]")
		this.template = this.querySelector("[data-language-option-template]")
		this.summary = this.querySelector("[data-language-summary]")
		try {
			this.flags = JSON.parse(this.querySelector("[data-language-flags]")?.textContent || "{}")
		} catch (error) {
			this.flags = {}
		}
		if (!this.trigger || !this.dialog || !this.form) return

		this.trigger.addEventListener("click", () => this.open())
		this.querySelectorAll("[data-language-cancel]").forEach((button) =>
			button.addEventListener("click", () => this.close()),
		)
		this.form.addEventListener("submit", (event) => {
			event.preventDefault()
			this.save()
		})
		// Klick auf den Hintergrund (außerhalb des Panels) schließt.
		this.dialog.addEventListener("click", (event) => {
			if (event.target === this.dialog) this.close()
		})
		// Esc: das native „cancel“ des Dialogs abfangen, damit auch das Schließen animiert wird.
		this.dialog.addEventListener("cancel", (event) => {
			event.preventDefault()
			this.close()
		})
		this.dialog.addEventListener("close", () => document.documentElement.classList.remove("language-switcher-open"))
		// Klick auf eine Sprache wechselt sofort (Machiel, 20.10.).
		this.optionsRoot?.addEventListener("click", (event) => {
			const option = event.target.closest("[data-language-option]")
			if (option) this.switchLanguage(option.dataset.language)
		})

		this.render()
		document.addEventListener("weglot.initialized", () => this.render())
		if (typeof window.Weglot?.on === "function") {
			try {
				window.Weglot.on("initialized", () => this.render())
			} catch (error) {
				// ältere Weglot-Version
			}
		}
		this.waitForLanguages()
	}

	// Ohne hreflang-Links (z. B. Vorschau-Theme) kommen die Sprachen nur aus Weglot. Lädt Weglot nach
	// diesem Skript, sind beim ersten render() noch keine Sprachen da und der Button bliebe versteckt
	// (Markus 22.10.). Deshalb kurz nachprüfen, bis die Sprachen da sind (max. 15 s).
	waitForLanguages() {
		if (!this.trigger?.hidden) return
		let tries = 0
		this.languageTimer = window.setInterval(() => {
			tries += 1
			this.render()
			if (!this.trigger.hidden || tries >= 50) window.clearInterval(this.languageTimer)
		}, 300)
		window.addEventListener("load", () => this.render(), { once: true })
	}

	flagFor(code) {
		const key = SD_LANGUAGE_FLAG_ALIASES[code.toLowerCase()] || sdPrimaryLanguage(code)
		return this.flags[key] || ""
	}

	render() {
		this.languages = sdAvailableLanguages()
		if (this.languages.length < 2) {
			this.trigger.hidden = true
			return
		}
		this.current = sdCurrentLanguage(this.languages)

		const triggerCode = this.trigger.querySelector("[data-language-trigger-code]")
		if (triggerCode) triggerCode.textContent = sdLanguageLabel(this.current)
		this.trigger.setAttribute("lang", this.current)
		this.trigger.hidden = false
		document.documentElement.classList.add("has-language-switcher")

		if (this.summary) this.summary.textContent = sdLanguageName(this.current, this.current)

		if (!this.optionsRoot || !this.template) return
		// Gewählte Sprache zuerst, dann die übrigen in Weglot-Reihenfolge (wie im Design).
		const ordered = [
			...this.languages.filter((language) => language.code === this.current),
			...this.languages.filter((language) => language.code !== this.current),
		]
		this.optionsRoot.replaceChildren(
			...ordered.map((language) => {
				const node = this.template.content.firstElementChild.cloneNode(true)
				node.dataset.language = language.code
				if (language.code === this.current) node.setAttribute("aria-current", "true")
				const image = node.querySelector("img")
				const fallback = node.querySelector(".language-switcher__flag-fallback")
				const languageFlag = this.flagFor(language.code)
				if (languageFlag) {
					image.src = languageFlag
					fallback.remove()
				} else {
					image.remove()
					fallback.textContent = sdLanguageLabel(language.code)
				}
				const name = node.querySelector(".language-switcher__option-name")
				name.textContent = sdLanguageName(language.code, language.code)
				name.setAttribute("lang", language.code)
				node.querySelector(".language-switcher__option-hint").textContent = sdLanguageName(
					language.code,
					this.current,
				)
				return node
			}),
		)
	}

	// Panel fährt von links ein und wieder hinaus (CSS-Übergang auf .is-open); ohne Bewegung
	// (prefers-reduced-motion) sofort.
	reducedMotion() {
		return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
	}

	open() {
		this.render()
		window.clearTimeout(this.closeTimer)
		this.dialog.classList.remove("is-open")
		document.documentElement.classList.add("language-switcher-open")
		if (typeof this.dialog.showModal === "function") {
			if (!this.dialog.open) this.dialog.showModal()
		} else this.dialog.setAttribute("open", "")
		// Nächster Frame: erst dann die Klasse setzen, sonst springt der Browser ohne Übergang.
		window.requestAnimationFrame(() => window.requestAnimationFrame(() => this.dialog.classList.add("is-open")))
		this.optionsRoot?.querySelector('[aria-current="true"]')?.focus({ preventScroll: true })
	}

	close() {
		const finish = () => {
			window.clearTimeout(this.closeTimer)
			if (typeof this.dialog.close === "function") {
				if (this.dialog.open) this.dialog.close()
			} else this.dialog.removeAttribute("open")
			document.documentElement.classList.remove("language-switcher-open")
			this.render()
			this.trigger.focus({ preventScroll: true })
		}
		this.dialog.classList.remove("is-open")
		if (this.reducedMotion()) return finish()
		// Dauer wie in custom.css (.language-switcher__dialog, 300 ms) plus Puffer.
		this.closeTimer = window.setTimeout(finish, 320)
	}

	switchLanguage(code) {
		const language = this.languages.find((entry) => entry.code === code)
		if (!language || code === this.current) return
		this.optionsRoot?.querySelectorAll("[data-language-option]").forEach((option) => {
			if (option.dataset.language === code) option.setAttribute("aria-current", "true")
			else option.removeAttribute("aria-current")
		})
		if (!language.href && typeof window.Weglot?.switchTo === "function") {
			window.Weglot.switchTo(language.code)
			return
		}
		window.location.assign(sdLanguageTargetUrl(language, this.languages).toString())
	}

	save() {
		// Die Sprache wechselt schon beim Klick; hier bleibt nur die Währung (falls angeboten).
		const target = new URL(window.location.href)

		// Währung (nur sichtbar, wenn der Shop mehrere Währungen hat): über das Shopify-Formular
		// wechseln und danach auf die Ziel-URL der gewählten Sprache zurückkehren.
		const chosenCountry = this.form.querySelector('input[name="currency"]:checked')
		const currencyForm = document.getElementById("language-switcher-currency-form")
		const currentCountry = currencyForm?.querySelector('input[name="country_code"]')?.value
		if (chosenCountry && currencyForm && chosenCountry.value !== currentCountry) {
			currencyForm.querySelector('input[name="country_code"]').value = chosenCountry.value
			currencyForm.querySelector('input[name="return_to"]').value = target.pathname + target.search + target.hash
			currencyForm.submit()
			return
		}

		this.close()
	}
}

if (!window.customElements.get("language-switcher")) {
	window.customElements.define("language-switcher", LanguageSwitcher)
}

// STE-19/STE-29: Message bar über dem Header (sections/announcement-bar-os.liquid).
// Prüft jede Sekunde, welcher Sale läuft (Start/Ende als Zeitstempel aus Liquid, Shop-Zeit),
// färbt die Leiste (Klasse message-bar--sale) und schreibt nur die Ziffern des Countdowns neu.
// Sale-Titel und -Text bleiben statisches HTML, das Weglot einmal übersetzt; das Ziffern-Element
// ist von Weglot ausgenommen, damit kein neues Segment pro Sekunde entsteht (STE-29). Die
// Einheiten (d/h/m/s, NL „u“, FR „j“ …) liefert der Browser in der Seitensprache (Intl).
const SD_COUNTDOWN_UNITS = ["day", "hour", "minute", "second"]
const sdCountdownFormatters = {}

function sdCountdownParts(milliseconds) {
	const total = Math.max(0, Math.floor(milliseconds / 1000))
	return {
		day: Math.floor(total / 86400),
		hour: Math.floor((total % 86400) / 3600),
		minute: Math.floor((total % 3600) / 60),
		second: total % 60,
	}
}

// Kurzform wie im Design („5d 14h 15m 42s“, NL „5d 14u 15m 42s“). Deutsch (Ausgangssprache) bleibt
// bei d/h/m/s wie bisher; die übrigen Sprachen nehmen die schmale Einheit des Browsers (Intl) und
// schreiben kurze Einheiten direkt an die Zahl (Intl liefert z. B. für NL „5 d“).
function sdFormatCountdown(milliseconds, language) {
	const parts = sdCountdownParts(milliseconds)
	const key = sdPrimaryLanguage(language) || "de"
	const fallback = { day: "d", hour: "h", minute: "m", second: "s" }
	const pad = (unit) => (unit === "minute" || unit === "second" ? 2 : 1)
	if (!sdCountdownFormatters[key] && key !== sdOriginalLanguage()) {
		sdCountdownFormatters[key] = {}
		SD_COUNTDOWN_UNITS.forEach((unit) => {
			try {
				sdCountdownFormatters[key][unit] = new Intl.NumberFormat(key, {
					style: "unit",
					unit,
					unitDisplay: "narrow",
					minimumIntegerDigits: pad(unit),
				})
			} catch (error) {
				sdCountdownFormatters[key][unit] = null
			}
		})
	}
	return SD_COUNTDOWN_UNITS.filter((unit) => unit !== "day" || parts.day > 0)
		.map((unit) => {
			const formatter = sdCountdownFormatters[key]?.[unit]
			if (formatter?.formatToParts) {
				const pieces = formatter.formatToParts(parts[unit])
				const unitText = pieces
					.filter((piece) => piece.type === "unit")
					.map((piece) => piece.value)
					.join("")
				if (unitText && unitText.replace(/\.$/, "").length <= 3) {
					const number = pieces
						.filter((piece) => piece.type === "integer")
						.map((piece) => piece.value)
						.join("")
					return number + unitText.replace(/\.$/, "")
				}
				return pieces.map((piece) => piece.value).join("")
			}
			return String(parts[unit]).padStart(pad(unit), "0") + fallback[unit]
		})
		.join(" ")
}

class MessageBar extends HTMLElement {
	connectedCallback() {
		this.sales = [...this.querySelectorAll("[data-sale]")].map((element) => ({
			element,
			start: Number(element.dataset.start) || 0,
			end: Number(element.dataset.end) || 0,
			timer: element.querySelector("[data-sale-timer]"),
		}))
		if (!this.sales.length) return
		this.update()
		this.interval = window.setInterval(() => this.update(), 1000)
		// Machiel 22.10.: Versandtext rechts ausblenden, sobald der Sale-Text ihn erreichen würde.
		// Gemessen wird, nicht geschätzt – Weglot-Übersetzungen sind je Sprache unterschiedlich lang.
		// Kurzer Timer statt requestAnimationFrame (läuft auch ohne gezeichnete Frames, bündelt Messungen).
		this.scheduleFit = () => {
			if (this.fitTimer) return
			this.fitTimer = window.setTimeout(() => {
				this.fitTimer = null
				this.fit()
			}, 50)
		}
		if ("ResizeObserver" in window) {
			this.resizeObserver = new ResizeObserver(this.scheduleFit)
			this.resizeObserver.observe(this)
		} else {
			window.addEventListener("resize", this.scheduleFit)
		}
		// Weglot tauscht die Texte nach dem Laden aus; der Countdown ändert seine Breite (Tage).
		this.mutationObserver = new MutationObserver(this.scheduleFit)
		this.mutationObserver.observe(this, { childList: true, characterData: true, subtree: true })
		document.fonts?.ready?.then(this.scheduleFit)
		this.fit()
	}

	disconnectedCallback() {
		window.clearInterval(this.interval)
		this.resizeObserver?.disconnect()
		this.mutationObserver?.disconnect()
		window.removeEventListener("resize", this.scheduleFit)
		if (this.fitTimer) window.clearTimeout(this.fitTimer)
	}

	// Desktop mit laufendem Sale: Platz für Sale-Text + Countdown in der Mitte prüfen.
	// - passt Mitte + beide Seiten nicht mehr → message-bar--compact (Versandtext aus)
	// - passt die Mitte auch neben dem Sprach-Button nicht symmetrisch → zusätzlich
	//   message-bar--tight (Mitte füllt den Rest, Sale-Text wird mit „…“ gekürzt, Countdown bleibt).
	// Mobil blendet die Leiste den Versandtext während eines Sales ohnehin aus (CSS).
	fit() {
		const inner = this.querySelector(".message-bar__inner")
		const start = this.querySelector(".message-bar__start")
		const end = this.querySelector(".message-bar__end")
		const sale = this.sales?.find((item) => !item.element.hidden)?.element
		this.classList.remove("message-bar--compact", "message-bar--tight")
		if (!inner || !start || !sale || !this.classList.contains("message-bar--sale")) return
		if (window.matchMedia("(max-width: 999px)").matches) return
		const innerStyle = window.getComputedStyle(inner)
		const available =
			inner.clientWidth - parseFloat(innerStyle.paddingLeft || 0) - parseFloat(innerStyle.paddingRight || 0)
		const centerWidth = sale.scrollWidth
		const startWidth = start.scrollWidth
		let endWidth = 0
		if (end && end.children.length) {
			const endStyle = window.getComputedStyle(end)
			endWidth =
				[...end.children].reduce((sum, child) => sum + child.scrollWidth, 0) +
				parseFloat(endStyle.paddingLeft || 0) +
				parseFloat(endStyle.paddingRight || 0)
		}
		// Mitte ist zentriert → beide Seiten brauchen die Breite der breiteren Seite.
		if (centerWidth + 2 * Math.max(startWidth, endWidth) <= available) return
		this.classList.add("message-bar--compact")
		if (centerWidth + 2 * startWidth > available) this.classList.add("message-bar--tight")
	}

	language() {
		if (!this.cachedLanguage || !this.languageChecked) {
			try {
				this.cachedLanguage = sdPrimaryLanguage(sdCurrentLanguage(sdAvailableLanguages()))
			} catch (error) {
				this.cachedLanguage = sdPrimaryLanguage(document.documentElement.lang) || "de"
			}
			// Weglot setzt die Sprache evtl. erst nach dem Start; daher nach ein paar Sekunden festhalten.
			this.languageChecks = (this.languageChecks || 0) + 1
			if (this.languageChecks > 5) this.languageChecked = true
		}
		return this.cachedLanguage
	}

	update(now = Date.now()) {
		const active = this.sales.find((sale) => sale.start <= now && now < sale.end)
		this.sales.forEach((sale) => {
			sale.element.hidden = sale !== active
		})
		const saleChanged = this.activeSale !== active
		this.activeSale = active
		this.classList.toggle("message-bar--sale", Boolean(active))
		if (saleChanged && this.scheduleFit) this.scheduleFit()
		if (active?.timer) {
			const text = sdFormatCountdown(active.end - now, this.language())
			if (active.timer.textContent !== text) active.timer.textContent = text
		}
		// Kein Sale mehr in Sicht: Intervall beenden.
		if (!active && this.sales.every((sale) => sale.end <= now)) window.clearInterval(this.interval)
	}
}

if (!window.customElements.get("message-bar")) {
	window.customElements.define("message-bar", MessageBar)
}
